import Trigger from '../../../es/trigger';
export default Trigger;
